import React from 'react';
import { VARIANTS_PER_PORTAL } from 'constants/env';
import './style.sass';

import { HeaderMiCuenta } from '../../../components/Header/HeaderMiCuenta'
import { ErrorBoundary } from '../../../components/Error/ErrorBoundary'



export function HeaderBarMovile(props){

    const {
        isLoged,
        profile
    } = props

    const hostName = window.location.origin;
    const pathName = window.location.pathname

    return(
        <div className="ocultarMenu2">
            {VARIANTS_PER_PORTAL?.menuMobile.map( ({title, iconClass, url, privateUrl, exactUrl, anchor, showOnlyLogin}, index) => 
                {
                    return(
                        <ErrorBoundary key={index}>
                            {
                                !showOnlyLogin || isLoged
                                    ?
                                        title !== "Registrate"
                                            ? Boolean(exactUrl) === true
                                                ?
                                                    <a
                                                        href={privateUrl ? privateUrl : url}
                                                        className={
                                                            pathName === privateUrl || pathName === url 
                                                                ? `${iconClass} active` 
                                                                : iconClass
                                                            }
                                                        aria-label={`Ir a menu ${title}`}
                                                    >
                                                        <span className="textReferenceMo">
                                                            <span className="smallTextMo">{title}</span>
                                                        </span>
                                                    </a>
                                                :
                                                    <a
                                                        href={privateUrl ? privateUrl : url}
                                                        className={
                                                            pathName.match(privateUrl) || pathName.match(url)
                                                                ? `${iconClass} active` 
                                                                : iconClass
                                                        }
                                                        aria-label={`Ir a menu ${title}`}
                                                    >
                                                        <span className="textReferenceMo">
                                                            <span className="smallTextMo">{title}</span>
                                                        </span>
                                                    </a>
                                            : <HeaderMiCuenta
                                                exactUrl={exactUrl}
                                                ruta={privateUrl ? isLoged ? privateUrl : `/login?redirect=${hostName}${privateUrl}` : url}
                                                className={iconClass}
                                                anchor={anchor}
                                                showOnlyLogin={showOnlyLogin}
                                                title={title}
                                                profile={profile}
                                            />
                                    : null
                            }
                        </ErrorBoundary>
                    )}
                )
            }
        </div>
    )
}
